import { createContext, useContext } from 'react';
import { RepublishEstateMutationActions } from '../../domain';
import { GqlRepublishEstateMutationActions } from '../graphql';

type RepublishEstateContextT = {
  republishEstateMutationActions: RepublishEstateMutationActions;
};

const defaultValue: RepublishEstateContextT = {
  republishEstateMutationActions: GqlRepublishEstateMutationActions,
};

export const RepublishEstateActionsContext = createContext<RepublishEstateContextT>(defaultValue);

export const useRepublishEstateActions = (): RepublishEstateContextT => useContext(RepublishEstateActionsContext);
